import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

import Logo from './logo'
import './navigation.css'

const Navigation = (props) => {
  const location = useLocation()
  const currentPath = location.pathname

  const [isMobileOpen, setIsMobileOpen] = useState(false)

  // Aktif sayfa alt kategorilerden biriyse ilgili dropdown otomatik açık başlasın
  const isAracKorumaActive = [
    '/arac-koruma',
    '/ppf-kaplama',
    '/arac-kaplama',
    '/boya-koruma',
    '/seramik-kaplama',
  ].includes(currentPath)

  const isDetailingActive = [
    '/detayli-arac-temizligi',
    '/boya-duzeltme',
    '/polisaj',
    '/far-parlatma',
    '/cam-filmi',
    '/buharli-arac-temizligi',
    '/detayli-motor-temizligi',
  ].includes(currentPath)

  const [aracKorumaOpen, setAracKorumaOpen] = useState(isAracKorumaActive)
  const [detailingOpen, setDetailingOpen] = useState(isDetailingActive)

  // URL değiştiğinde ilgili dropdown'ı açık tut ve mobil menüyü kapat
  useEffect(() => {
    if (isAracKorumaActive) setAracKorumaOpen(true)
    if (isDetailingActive) setDetailingOpen(true)
    setIsMobileOpen(false)
  }, [currentPath, isAracKorumaActive, isDetailingActive])

  // Mobil menü açıkken body kaydırmayı engelle
  useEffect(() => {
    if (isMobileOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isMobileOpen])

  // ESC tuşu ile mobil menüyü kapat
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isMobileOpen) {
        setIsMobileOpen(false)
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isMobileOpen])

  const closeMobile = () => {
    setIsMobileOpen(false)
  }

  return (
    <div className="navigation-root-container">
      {/* ================= DESKTOP & MOBİL ÜST BAR NAVİGASYON ================= */}
      <nav
        aria-label="Ana Navigasyon"
        className="navigation-sidebar navigation-thq-navigation-sidebar-elm"
      >
        <div className="navigation-sidebar-inner">
          {/* Logo ve Mobil Menü Butonu */}
          <div className="navigation-sidebar-head">
            <Link to="/" className="navigation-brand-link" onClick={closeMobile}>
              <Logo isOnDarkBackground={true}></Logo>
            </Link>

            <button
              type="button"
              id="sidebar-mobile-open"
              aria-label={isMobileOpen ? 'Menüyü Kapat' : 'Menüyü Aç'}
              className="navigation-mobile-trigger"
              onClick={() => setIsMobileOpen(!isMobileOpen)}
            >
              {isMobileOpen ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="3" y1="12" x2="21" y2="12"></line>
                  <line x1="3" y1="6" x2="21" y2="6"></line>
                  <line x1="3" y1="18" x2="21" y2="18"></line>
                </svg>
              )}
            </button>
          </div>

          {/* Menü Linkleri */}
          <div className="navigation-sidebar-links">
            {/* 1. ANA SAYFA */}
            <Link
              to="/"
              className={`navigation-navlink ${currentPath === '/' ? 'is-active' : ''}`}
              onClick={closeMobile}
            >
              <div className={`navigation-link ${currentPath === '/' ? 'is-active' : ''}`}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect width="7" height="9" x="3" y="3" rx="1"></rect>
                  <rect width="7" height="5" x="14" y="3" rx="1"></rect>
                  <rect width="7" height="9" x="14" y="12" rx="1"></rect>
                  <rect width="7" height="5" x="3" y="16" rx="1"></rect>
                </svg>
                <span>ANA SAYFA</span>
              </div>
            </Link>

            {/* 2. ARAÇ KORUMA DROPDOWN */}
            <div
              className={`navigation-group ${aracKorumaOpen ? 'is-open' : ''} ${
                isAracKorumaActive ? 'has-active-child' : ''
              }`}
            >
              <button
                type="button"
                className={`navigation-group-trigger ${isAracKorumaActive ? 'is-parent-active' : ''}`}
                onClick={() => setAracKorumaOpen(!aracKorumaOpen)}
                aria-expanded={aracKorumaOpen}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </svg>
                <span>ARAÇ KORUMA</span>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={`navigation-chevron ${aracKorumaOpen ? 'rotate' : ''}`}
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
              {aracKorumaOpen && (
                <div className="navigation-submenu">
                  <Link
                    to="/ppf-kaplama"
                    className={`navigation-sublink ${currentPath === '/ppf-kaplama' ? 'is-active' : ''}`}
                    onClick={closeMobile}
                  >
                    PPF KAPLAMA
                  </Link>
                  <Link
                    to="/arac-kaplama"
                    className={`navigation-sublink ${currentPath === '/arac-kaplama' ? 'is-active' : ''}`}
                    onClick={closeMobile}
                  >
                    ARAÇ KAPLAMA
                  </Link>
                  <Link
                    to="/boya-koruma"
                    className={`navigation-sublink ${currentPath === '/boya-koruma' ? 'is-active' : ''}`}
                    onClick={closeMobile}
                  >
                    BOYA KORUMA
                  </Link>
                  <Link
                    to="/seramik-kaplama"
                    className={`navigation-sublink ${currentPath === '/seramik-kaplama' ? 'is-active' : ''}`}
                    onClick={closeMobile}
                  >
                    SERAMİK KAPLAMA
                  </Link>
                </div>
              )}
            </div>

            {/* 3. DETAILING DROPDOWN */}
            <div
              className={`navigation-group ${detailingOpen ? 'is-open' : ''} ${
                isDetailingActive ? 'has-active-child' : ''
              }`}
            >
              <button
                type="button"
                className={`navigation-group-trigger ${isDetailingActive ? 'is-parent-active' : ''}`}
                onClick={() => setDetailingOpen(!detailingOpen)}
                aria-expanded={detailingOpen}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22a1 1 0 0 1 0-20a10 9 0 0 1 10 9a5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z"></path>
                  <circle cx="13.5" cy="6.5" r=".5" fill="currentColor"></circle>
                  <circle cx="17.5" cy="10.5" r=".5" fill="currentColor"></circle>
                  <circle cx="6.5" cy="12.5" r=".5" fill="currentColor"></circle>
                  <circle cx="8.5" cy="7.5" r=".5" fill="currentColor"></circle>
                </svg>
                <span>DETAILING</span>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className={`navigation-chevron ${detailingOpen ? 'rotate' : ''}`}
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>
              {detailingOpen && (
                <div className="navigation-submenu">
                  <Link
                    to="/detayli-arac-temizligi"
                    className={`navigation-sublink ${
                      currentPath === '/detayli-arac-temizligi' ? 'is-active' : ''
                    }`}
                    onClick={closeMobile}
                  >
                    DETAYLI ARAÇ TEMİZLİĞİ
                  </Link>
                  <Link
                    to="/boya-duzeltme"
                    className={`navigation-sublink ${currentPath === '/boya-duzeltme' ? 'is-active' : ''}`}
                    onClick={closeMobile}
                  >
                    BOYA DÜZELTME
                  </Link>
                  <Link
                    to="/polisaj"
                    className={`navigation-sublink ${currentPath === '/polisaj' ? 'is-active' : ''}`}
                    onClick={closeMobile}
                  >
                    POLİSAJ
                  </Link>
                  <Link
                    to="/far-parlatma"
                    className={`navigation-sublink ${currentPath === '/far-parlatma' ? 'is-active' : ''}`}
                    onClick={closeMobile}
                  >
                    FAR PARLATMA
                  </Link>
                  <Link
                    to="/cam-filmi"
                    className={`navigation-sublink ${currentPath === '/cam-filmi' ? 'is-active' : ''}`}
                    onClick={closeMobile}
                  >
                    CAM FİLMİ
                  </Link>
                  <Link
                    to="/buharli-arac-temizligi"
                    className={`navigation-sublink ${
                      currentPath === '/buharli-arac-temizligi' ? 'is-active' : ''
                    }`}
                    onClick={closeMobile}
                  >
                    BUHARLI ARAÇ TEMİZLİĞİ
                  </Link>
                  <Link
                    to="/detayli-motor-temizligi"
                    className={`navigation-sublink ${
                      currentPath === '/detayli-motor-temizligi' ? 'is-active' : ''
                    }`}
                    onClick={closeMobile}
                  >
                    DETAYLI MOTOR TEMİZLİĞİ
                  </Link>
                </div>
              )}
            </div>

            {/* 4. PROJELER */}
            <Link
              to="/projeler"
              className={`navigation-navlink ${currentPath === '/projeler' ? 'is-active' : ''}`}
              onClick={closeMobile}
            >
              <div className={`navigation-link ${currentPath === '/projeler' ? 'is-active' : ''}`}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594zM20 2v4m2-2h-4"></path>
                  <circle cx="4" cy="20" r="2"></circle>
                </svg>
                <span>PROJELER</span>
              </div>
            </Link>

            {/* 5. GALERİ */}
            <Link
              to="/galeri"
              className={`navigation-navlink ${currentPath === '/galeri' ? 'is-active' : ''}`}
              onClick={closeMobile}
            >
              <div className={`navigation-link ${currentPath === '/galeri' ? 'is-active' : ''}`}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z"></path>
                  <circle cx="12" cy="13" r="3"></circle>
                </svg>
                <span>GALERİ</span>
              </div>
            </Link>

            {/* 6. BLOG */}
            <Link
              to="/blog"
              className={`navigation-navlink ${currentPath === '/blog' ? 'is-active' : ''}`}
              onClick={closeMobile}
            >
              <div className={`navigation-link ${currentPath === '/blog' ? 'is-active' : ''}`}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                </svg>
                <span>BLOG</span>
              </div>
            </Link>

            {/* 7. HAKKIMIZDA */}
            <Link
              to="/hakkimizda"
              className={`navigation-navlink ${currentPath === '/hakkimizda' ? 'is-active' : ''}`}
              onClick={closeMobile}
            >
              <div className={`navigation-link ${currentPath === '/hakkimizda' ? 'is-active' : ''}`}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
                <span>HAKKIMIZDA</span>
              </div>
            </Link>

            {/* 8. İLETİŞİM */}
            <Link
              to="/iletisim"
              className={`navigation-navlink ${currentPath === '/iletisim' ? 'is-active' : ''}`}
              onClick={closeMobile}
            >
              <div className={`navigation-link ${currentPath === '/iletisim' ? 'is-active' : ''}`}>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span>İLETİŞİM</span>
              </div>
            </Link>
          </div>

          <div className="navigation-sidebar-spacer"></div>

          {/* Alt İletişim Bilgileri */}
          <div className="navigation-sidebar-contact">
            <div className="navigation-contact-group">
              <span className="navigation-contact-label">STÜDYO</span>
              <address className="navigation-address">
                Conrad Istanbul Bosphorus Otoparkı
                <br />
                Beşiktaş / İstanbul
              </address>
            </div>

            <div className="navigation-contact-actions">
              <a href="tel:+905346442153" className="navigation-contact-btn">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                <span>0534 644 21 53</span>
              </a>

              <a
                href="https://wa.me/905346442153"
                target="_blank"
                rel="noreferrer noopener"
                className="navigation-contact-btn navigation-whatsapp-btn"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 1 1-7.6-11.7 8.38 8.38 0 0 1 3.8.9L21 3z"></path>
                </svg>
                <span>WhatsApp Destek</span>
              </a>
            </div>

            <div className="navigation-footer-meta">
              <span className="navigation-hours">Pzt–Cmt 08:30–19:00</span>
            </div>
          </div>
        </div>

        {/* ================= MOBİL SLIDE-IN / FULLSCREEN MENÜ ================= */}
        <div
          id="navigation-mobile-overlay"
          aria-hidden={!isMobileOpen}
          className={`navigation-mobile-overlay ${isMobileOpen ? 'is-active' : ''}`}
        >
          <div className="navigation-mobile-content">
            <div className="navigation-mobile-header">
              <Link to="/" onClick={closeMobile}>
                <Logo isOnDarkBackground={true}></Logo>
              </Link>
              <button
                type="button"
                id="sidebar-mobile-close"
                aria-label="Menüyü Kapat"
                className="navigation-mobile-close"
                onClick={closeMobile}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>

            <div className="navigation-mobile-body">
              {/* Mobil Menü Linkleri */}
              <div className="navigation-mobile-links">
                <Link
                  to="/"
                  className={`navigation-mobile-item ${currentPath === '/' ? 'is-active' : ''}`}
                  onClick={closeMobile}
                >
                  ANA SAYFA
                </Link>

                <div className="navigation-mobile-group">
                  <button
                    type="button"
                    className="navigation-mobile-trigger-btn"
                    onClick={() => setAracKorumaOpen(!aracKorumaOpen)}
                  >
                    <span>ARAÇ KORUMA</span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={`navigation-chevron ${aracKorumaOpen ? 'rotate' : ''}`}
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </button>
                  {aracKorumaOpen && (
                    <div className="navigation-mobile-sub">
                      <Link
                        to="/ppf-kaplama"
                        className={currentPath === '/ppf-kaplama' ? 'is-active' : ''}
                        onClick={closeMobile}
                      >
                        PPF KAPLAMA
                      </Link>
                      <Link
                        to="/arac-kaplama"
                        className={currentPath === '/arac-kaplama' ? 'is-active' : ''}
                        onClick={closeMobile}
                      >
                        ARAÇ KAPLAMA
                      </Link>
                      <Link
                        to="/boya-koruma"
                        className={currentPath === '/boya-koruma' ? 'is-active' : ''}
                        onClick={closeMobile}
                      >
                        BOYA KORUMA
                      </Link>
                      <Link
                        to="/seramik-kaplama"
                        className={currentPath === '/seramik-kaplama' ? 'is-active' : ''}
                        onClick={closeMobile}
                      >
                        SERAMİK KAPLAMA
                      </Link>
                    </div>
                  )}
                </div>

                <div className="navigation-mobile-group">
                  <button
                    type="button"
                    className="navigation-mobile-trigger-btn"
                    onClick={() => setDetailingOpen(!detailingOpen)}
                  >
                    <span>DETAILING</span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={`navigation-chevron ${detailingOpen ? 'rotate' : ''}`}
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </button>
                  {detailingOpen && (
                    <div className="navigation-mobile-sub">
                      <Link
                        to="/detayli-arac-temizligi"
                        className={currentPath === '/detayli-arac-temizligi' ? 'is-active' : ''}
                        onClick={closeMobile}
                      >
                        DETAYLI ARAÇ TEMİZLİĞİ
                      </Link>
                      <Link
                        to="/boya-duzeltme"
                        className={currentPath === '/boya-duzeltme' ? 'is-active' : ''}
                        onClick={closeMobile}
                      >
                        BOYA DÜZELTME
                      </Link>
                      <Link
                        to="/polisaj"
                        className={currentPath === '/polisaj' ? 'is-active' : ''}
                        onClick={closeMobile}
                      >
                        POLİSAJ
                      </Link>
                      <Link
                        to="/far-parlatma"
                        className={currentPath === '/far-parlatma' ? 'is-active' : ''}
                        onClick={closeMobile}
                      >
                        FAR PARLATMA
                      </Link>
                      <Link
                        to="/cam-filmi"
                        className={currentPath === '/cam-filmi' ? 'is-active' : ''}
                        onClick={closeMobile}
                      >
                        CAM FİLMİ
                      </Link>
                      <Link
                        to="/buharli-arac-temizligi"
                        className={currentPath === '/buharli-arac-temizligi' ? 'is-active' : ''}
                        onClick={closeMobile}
                      >
                        BUHARLI ARAÇ TEMİZLİĞİ
                      </Link>
                      <Link
                        to="/detayli-motor-temizligi"
                        className={currentPath === '/detayli-motor-temizligi' ? 'is-active' : ''}
                        onClick={closeMobile}
                      >
                        DETAYLI MOTOR TEMİZLİĞİ
                      </Link>
                    </div>
                  )}
                </div>

                <Link
                  to="/projeler"
                  className={`navigation-mobile-item ${currentPath === '/projeler' ? 'is-active' : ''}`}
                  onClick={closeMobile}
                >
                  PROJELER
                </Link>
                <Link
                  to="/galeri"
                  className={`navigation-mobile-item ${currentPath === '/galeri' ? 'is-active' : ''}`}
                  onClick={closeMobile}
                >
                  GALERİ
                </Link>
                <Link
                  to="/blog"
                  className={`navigation-mobile-item ${currentPath === '/blog' ? 'is-active' : ''}`}
                  onClick={closeMobile}
                >
                  BLOG
                </Link>
                <Link
                  to="/hakkimizda"
                  className={`navigation-mobile-item ${currentPath === '/hakkimizda' ? 'is-active' : ''}`}
                  onClick={closeMobile}
                >
                  HAKKIMIZDA
                </Link>
                <Link
                  to="/iletisim"
                  className={`navigation-mobile-item ${currentPath === '/iletisim' ? 'is-active' : ''}`}
                  onClick={closeMobile}
                >
                  İLETİŞİM
                </Link>
              </div>

              {/* Mobil Stüdyo & İletişim */}
              <div className="navigation-mobile-contact">
                <span className="navigation-contact-label">STÜDYO</span>
                <p className="navigation-address">
                  Conrad Istanbul Bosphorus Otoparkı, Beşiktaş
                </p>
                <div className="navigation-mobile-actions-list">
                  <a href="tel:+905346442153" className="navigation-contact-btn">
                    ARA: 0534 644 21 53
                  </a>
                  <a
                    href="https://wa.me/905346442153"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="navigation-contact-btn navigation-whatsapp-btn"
                  >
                    WHATSAPP İLE YAZIN
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* ================= MOBİL STICKY BOTTOM CTA (ARA - WHATSAPP - TEKLİF AL) ================= */}
      <aside aria-label="Hızlı İletişim" className="mobile-sticky-cta-bar">
        <a href="tel:+905346442153" className="mobile-cta-btn mobile-cta-call">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
          </svg>
          <span>ARA</span>
        </a>

        <a
          href="https://wa.me/905346442153"
          target="_blank"
          rel="noreferrer noopener"
          className="mobile-cta-btn mobile-cta-whatsapp"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 1 1-7.6-11.7 8.38 8.38 0 0 1 3.8.9L21 3z"></path>
          </svg>
          <span>WHATSAPP</span>
        </a>

        <Link to="/iletisim" className="mobile-cta-btn mobile-cta-quote">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
          </svg>
          <span>TEKLİF AL</span>
        </Link>
      </aside>
    </div>
  )
}

Navigation.defaultProps = {}

Navigation.propTypes = {}

export default Navigation
